/**
 * By default, the bubble appears above (bottom:100%) if there is enough space; 
 * if the icon is too close to the top edge of the container, it switches to below (top:100%).
 * Inside a .modal the threshold is larger (header/padding + bubble).
 */

const MIN_SPACE_ABOVE = 140;
/** Extra margin when the tip is inside a modal (more restrictive = it switches to below sooner). */
const MODAL_MIN_SPACE_EXTRA = 150;

function scrollContainer(el) {
  let p = el.parentElement;
  while (p) {
    const { overflowY } = window.getComputedStyle(p);
    if (/(auto|scroll|overlay)/.test(overflowY) && p.scrollHeight > p.clientHeight) {
      return p;
    }
    p = p.parentElement;
  }
  return null;
}

function minSpaceForTip(tip) {
  return tip.closest(".modal")
    ? MIN_SPACE_ABOVE + MODAL_MIN_SPACE_EXTRA
    : MIN_SPACE_ABOVE;
}

function syncHelpTips() {
  const snapshot = [];

  document.querySelectorAll(".help-tip").forEach((tip) => {
    const bubble = tip.querySelector("p");
    if (!bubble) return;

    const container = scrollContainer(tip);
    const topEdge = container
      ? container.getBoundingClientRect().top
      : 0;
    const tipTop = tip.getBoundingClientRect().top;
    const spaceAbove = tipTop - topEdge;
    const minRequired = minSpaceForTip(tip);
    const placement =
      spaceAbove < minRequired ? "below (top:100%)" : "above (bottom:100%)";

    if (spaceAbove < minRequired) {
      bubble.style.top = "100%";
      bubble.style.bottom = "auto";
    } else {
      bubble.style.top = "auto";
      bubble.style.bottom = "100%";
    }

    snapshot.push({
      tipTop: Math.round(tipTop),
      topEdge: Math.round(topEdge),
      spaceAbove: Math.round(spaceAbove),
      minRequired,
      inModal: Boolean(tip.closest(".modal")),
      placement,
      scrollContainer: container
        ? container.className || container.id || container.tagName
        : "viewport",
    });
  });
}

let hooked;

export function initHelpTipScrollPositioning() {
  if (hooked) return;
  hooked = true;
  window.addEventListener("scroll", syncHelpTips, true);
  window.addEventListener("resize", syncHelpTips);
  syncHelpTips();
}